import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cx from 'clsx'
import SVG from 'react-inlinesvg'
import _size from 'lodash/size'

import { Link, navigate } from 'gatsby'

// Redux
import {
  setViewType,
  loadFilter,
  setModal,
  setSort,
} from '~lib/saga/filter/actions'
// Context
import { allCategories } from '~2023/context/GlobalContext'
// Components
import { ListIcon, GridIcon } from '~2023/components/Icons'
import { SortByItem } from '~2023/components/SortBy'
// Styles
import useStyles from './ContainerHeader.style'
// Utils
import { categories } from '~2023/utils'

function CategoryLink({
  filterSize,
  category,
  filterId,
  i,
  classes,
  handleFilterLoad,
}) {
  const isSelected = 1 === filterSize && category.id === filterId[0]

  // Special behavior for FOTY
  if ('fandomOfTheYear' === category.id) {
    return (
      <Link
        key={`category--${category.id}`}
        style={{ whiteSpace: 'nowrap' }}
        className={cx(
          classes.categoryLink,
          isSelected && classes.categoryLinkSelected
        )}
        // onClick={(event) => handleFilterLoad(event, [category.id])}
        to={`/2023/taylor-swift`}
      >
        {category.title}
      </Link>
    )
  }

  return (
    <>
      {0 !== i ? (
        <span style={{ paddingRight: '.5rem', paddingLeft: '.5rem' }}>•</span>
      ) : (
        ''
      )}
      <Link
        key={`category--${category.id}`}
        style={{ whiteSpace: 'nowrap' }}
        className={cx(
          classes.categoryLink,
          isSelected && classes.categoryLinkSelected
        )}
        onClick={(event) => handleFilterLoad(event, [category.id])}
        to={`/${category.id}`}
      >
        {category.title}
      </Link>
    </>
  )
}

const filterSelector = (state) => state.filter
const ContainerHeader = () => {
  const dispatch = useDispatch()
  const {
    data: {
      id: filterId,
      isFiltered,
      title: filterTitle,
      size: filterSize,
      sort: filterSort,
      viewType: filterViewType,
      year: filterYear,
    },
    default: { year: yearDefault },
  } = useSelector(filterSelector)

  const classes = useStyles({
    categoryId: isFiltered ? filterId : 'football',
    categoryTitle: filterTitle,
  })

  const handleViewType = (type) => dispatch(setViewType(type))

  const handleFilterLoad = (event, id) => {
    event.preventDefault()
    dispatch(loadFilter(id))
    dispatch(setModal(false))
    // @note[request] If we move between categories, force `rank`
    dispatch(setSort('rank'))
    navigate(`/${id}`)
  }

  return (
    <div
      className={cx(
        classes.gridHeader,
        isFiltered && classes.gridHeaderFilter,
        'rank' !== filterSort && classes.gridHeaderSort,
        yearDefault !== filterYear && classes.gridHeaderYear
      )}
    >
      <div className={cx(classes.buttonGroup)}>
        <button
          className={cx(
            classes.button,
            classes.buttonGrid,
            'card' === filterViewType && classes.selected,
            'card' === filterViewType && classes.buttonGridSelected
          )}
          onClick={() => handleViewType('card')}
          type="button"
        >
          <span>Grid</span>
          <SVG
            src={GridIcon}
            width={12}
            height={12}
            title="Switch to Grid View"
            description="A square icon with masonry grid layout"
          />
        </button>
        <button
          className={cx(
            classes.button,
            classes.buttonList,
            'list' === filterViewType && classes.selected,
            'list' === filterViewType && classes.buttonListSelected
          )}
          onClick={() => handleViewType('list')}
          type="button"
        >
          <SVG
            src={ListIcon}
            width={12}
            height={10}
            title="Switch to List View"
            description="A square icon horizontally ordered bars in 3 rows"
          />
          <span>List</span>
        </button>
      </div>
      {yearDefault !== filterYear && (
        <>
          {0 < filterSize && (
            <h3
              className={cx(classes.title, classes.yearTitle)}
              data-text={filterYear}
            >
              {filterYear}
            </h3>
          )}
        </>
      )}
      {!isFiltered && yearDefault === filterYear && (
        <p className={cx(classes.leadText)}>
          FanSided Fandoms of the Year is an authentic celebration of fan
          culture, bringing together the FanSided community of readers and
          writers to celebrate the teams, players, competitions, movies,
          experiences, actors, music, television shows, games and more that made
          us want to stand up and cheer in 2023.
        </p>
      )}
      {1 === filterSize && (
        <h1 className={cx(classes.title)} data-text={filterTitle}>
          {filterTitle}
        </h1>
      )}
      <div className={cx(classes.sortFilterContainer)}>
        {'all' !== filterTitle.toLowerCase() &&
        _size(allCategories) !== _size(filterId) ? (
          <SortByItem filter={true} sortFilter={filterTitle} />
        ) : null}
      </div>
      <div className={cx(classes.categoryNavContainer)}>
        <div style={{ display: 'flex', height: 28 }}>
          {categories
            .slice(0, Math.floor(categories.length / 2) - 2)
            .map((category, i) => {
              return (
                <CategoryLink
                  key={`category--${category.id}`}
                  filterSize={filterSize}
                  category={category}
                  filterId={filterId}
                  i={i}
                  classes={classes}
                  handleFilterLoad={handleFilterLoad}
                />
              )
            })}
        </div>

        <div style={{ display: 'flex', height: 28 }}>
          {categories
            .slice(Math.floor(categories.length / 2) - 2)
            .map((category, i) => {
              return (
                <CategoryLink
                  key={`category--${category.id}`}
                  filterSize={filterSize}
                  category={category}
                  filterId={filterId}
                  i={i}
                  classes={classes}
                  handleFilterLoad={handleFilterLoad}
                />
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default ContainerHeader
